import * as actions from "./actions";
import { importEpic } from "./middleware";
import { createNotificationsEpicForAction } from "./notification";
export const importUrl = ({ scenario, workspace, program, mode, panelName }) => {
    let position = "";
    let fixedPanelName = panelName.slice();
    if (panelName.indexOf("_") !== -1) {
        position = panelName.substring(panelName.indexOf("_") + 1);
        fixedPanelName = panelName.substring(0, panelName.indexOf("_"));
        return `/api/v1/override/${scenario}/${workspace}/${program}/${mode}/${fixedPanelName}/${position}`;
    }
    return `/api/v1/override/${scenario}/${workspace}/${program}/${mode}/${panelName}`;
};
export const createImportExport = () => {
    const initialState = {};
    function reducer(state = initialState, action) {
        switch (action.type) {
            default:
                return state;
        }
    }
    const middleware = [
        importEpic(importUrl),
        createNotificationsEpicForAction()
    ];
    const selectors = {};
    return { actions, reducer, middleware, selectors };
};
export const UploadFileDuck = createImportExport();
//# sourceMappingURL=index.js.map